// src/pages/PaymentSuccess.js
import React, { useEffect, useState } from 'react';
import { useNavigate,NavLink } from 'react-router-dom';
import { FaCheckCircle } from "react-icons/fa";
import { CheckCircle, Star, ExternalLink } from 'lucide-react';


const PaymentSuccessContainer = () => {
    const [showModal, setShowModal] = useState(true);
    const navigate = useNavigate();
    const closeModal = () => {
        setShowModal(false);
        navigate('/mypage/reservation');
      };

// インポートに追加

// JSXの差分
return (
    <div className="sunny_container">
        {showModal && (
            <div className="modal-overlay" onClick={closeModal}>
                <div className="modal-content success_modal payment_success" onClick={(e) => e.stopPropagation()}>
                    <span className="close-button" onClick={closeModal}>✖︎</span>
                    
                    <div className="success_animation">
                        <div className="modal_icon success_icon large">
                            <CheckCircle className="icon" />
                        </div>
                        <p className="modal_title large">お支払い完了</p>
                        <p className="modal_subtitle">ありがとうございます。お支払いが正常に処理されました。</p>
                    </div>

                    <div className="survey_section">
                        <div className="survey_header">
                            <Star className="survey_icon" />
                            <p className="survey_title">診察後アンケートのお願い</p>
                        </div>
                        
                        <div className="survey_description">
                            <p>サービスの質向上のために診察後アンケートを実施しております。ぜひご協力ください。</p>
                        </div>

                        <NavLink 
                            to="https://docs.google.com/forms/d/e/1FAIpQLSewIyXgmlxB1lA-G1nWzh0M52eYjS9EGgPkPph59zr5eK1tuQ/viewform?usp=header" 
                            className="survey_button"
                        >
                            <ExternalLink className="button_icon" />
                            アンケートに回答する
                        </NavLink>
                    </div>
                </div>
            </div>
        )}
    </div>
);
};

export default PaymentSuccessContainer;